export enum ProviderPrescriberType {
  mddo = 'mddo',
  pmhnparpn = 'pmhnparpn',
}
